import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
export function HowItWorks() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const steps = [{
    number: '1',
    title: 'Descarga el Bundle',
    description: 'Recibe acceso inmediato al eBook y al Audio en tu correo.'
  }, {
    number: '2',
    title: 'Escucha y Aprende',
    description: 'Revisa la técnica de 7 minutos (te tomará menos de 15 minutos leerlo).'
  }, {
    number: '3',
    title: 'Aplica esta noche',
    description: 'Sigue los pasos y mira cómo el tiempo de llanto se reduce drásticamente desde la primera vez.'
  }];
  return <section ref={ref} className="w-full bg-cream py-16 md:py-24 px-6" data-id="element-132">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.7
    }} className="max-w-5xl mx-auto" data-id="element-133">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-warm-brown mb-12 text-center" data-id="element-134">
          Cómo funciona
        </h2>

        <div className="relative" data-id="element-135">
          {/* Connection line */}
          <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-0.5 bg-soft-gold/30 transform -translate-x-1/2" data-id="element-136" />

          <div className="space-y-12" data-id="element-137">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: index % 2 === 0 ? -30 : 30
          }} animate={isInView ? {
            opacity: 1,
            x: 0
          } : {}} transition={{
            duration: 0.6,
            delay: index * 0.2
          }} className={`flex flex-col md:flex-row items-center gap-6 ${index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'}`} data-id="element-138">
                <div className="flex-1 bg-white rounded-xl p-6 md:p-8 shadow-lg" data-id="element-139">
                  <h3 className="font-serif text-2xl font-semibold text-warm-brown mb-3" data-id="element-140">
                    {step.title}
                  </h3>
                  <p className="text-lg text-warm-brown/80 leading-relaxed" data-id="element-141">
                    {step.description}
                  </p>
                </div>

                <div className="flex-shrink-0 w-16 h-16 bg-soft-gold rounded-full flex items-center justify-center shadow-lg z-10" data-id="element-142">
                  <span className="font-serif text-2xl font-bold text-white" data-id="element-143">
                    {step.number}
                  </span>
                </div>

                <div className="flex-1 hidden md:block" data-id="element-144" />
              </motion.div>)}
          </div>
        </div>
      </motion.div>
    </section>;
}